import React from 'react';

import { MAIN_THEME } from '@styles';

import EnhancedInputsWrapper from './EnhancedInputsWrapper';

import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

export interface IEnhancedTextAreaProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  type: string;
  name: string;
  title: string;
  error?: string;
  rows?: number;
  value: string | number;
  onBlur: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const useStyles = makeStyles()(() => ({
  labelWrapper: {
    display: 'block',
    textAlign: 'left',
    fontSize: MAIN_THEME.fontSize.rg,
    lineHeight: '15px'
  },
  label: {
    display: 'block',
    color: MAIN_THEME.color.black,
    textAlign: 'left',
    fontFamily: MAIN_THEME.font.regular
  },
  input: {
    fontSize: MAIN_THEME.fontSize.sm,
    lineHeight: '15px',
    width: '100%',
    padding: '10px 15px 5px 15px',
    margin: '0 auto',
    backgroundColor: MAIN_THEME.color.white98,
    border: `1px solid ${MAIN_THEME.color.white86}`,
    boxSizing: 'border-box',
    borderRadius: '5px',
    fontFamily: MAIN_THEME.font.regular,
    resize: 'none',
    '&:focus-visible': {
      outline: 'none'
    },
    '&::placeholder': {
      color: 'rgba(0, 0, 0, 0.20)',
      fontStyle: 'italic'
    }
  },
  inputError: {
    borderColor: MAIN_THEME.color.red,
    outlineColor: MAIN_THEME.color.red,
    fontFamily: MAIN_THEME.font.regular
  }
}));

const EnhancedTextArea: React.FC<IEnhancedTextAreaProps> = ({
  rows = 6,
  className,
  error,
  name,
  title,
  value,
  placeholder,
  type,
  style,
  disabled,
  onChange,
  onBlur
}) => {
  const { classes } = useStyles();

  return (
    <>
      <EnhancedInputsWrapper
        title={title}
        error={error}
        name={name}
        className={className}
        style={style}
      >
        <textarea
          className={clsx(classes.input, {
            [classes.inputError]: error
          })}
          rows={rows}
          title={title}
          id={name}
          name={name}
          aria-invalid={!!error}
          aria-describedby={`errorMsg-${name}`}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
        />
      </EnhancedInputsWrapper>
    </>
  );
};

export default EnhancedTextArea;
